/**
 * Display text for an extra-night rate (points or co-pay). `null` means there is no nightly price,
 * so an extra night can't be priced or booked; `0` is a real rate — a free extra night — and must
 * not read the same as a missing one.
 */
export function formatExtraNightRate(value: number | null): string {
  return value === null ? 'n/a (no nightly price)' : String(value);
}
